module.exports = __webpack_public_path__ + "img/IT0000320091029.e66ac90e.png";